import React from "react";
import JsonEditorComponent from "../../JsonEditorComponent";

export class ClientSideEvent extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let values = this.props.values;
        let myHandleChange = this.props.myHandleChange;
        let setFieldValue = this.props.setFieldValue;
        let jsonData = {};
        try {
            jsonData = JSON.parse(values.customClientData)
        } catch (e) {
            console.log(e);
        }
        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">ClientClass</label>
                    <div className="col-sm-10">
                        <input className="form-control" type="text" name="clientClass" onChange={myHandleChange}
                               value={values.clientClass || ""}/>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">CustomClientData</label>
                    <div className="col-sm-8">
                        <input className="form-control" type="text" name="customClientData" onChange={myHandleChange}
                               value={values.customClientData || ""}/>
                    </div>
                    <div className="col-sm-2">
                        <JsonEditorComponent
                            className="btn btn-icon btn-light  ml-1"
                            data={jsonData}
                            saveHandler={(data) => setFieldValue("customClientData", JSON.stringify(data))}/>
                    </div>

                </div>
            </div>
        );
    }
}